import * as api from "../../../../../api"

//------------------------------------------------------------------------------

export default function useStateActions(appContext) {
  const [{ token }, dispatch] = appContext

  // -------------------------------------

  async function getUserUnreadedMessages() {
    try {
      const unreadedMessagesResponse = await api.getUserUnreadedMessages(token)

      dispatch({
        type: "REFRESH_USER_UNREADED_MESSAGES",
        payload: unreadedMessagesResponse.unreadedMessages,
      })
    } catch (error) {
      throw new Error(error)
    }
  }

  // -------------------------------------

  const actions = {
    getUserUnreadedMessages,
  }

  return actions
}
